import { gql } from "@apollo/client";

const SAVE_REQUERIMIENTOS_ACTUALES_VISITA_CD = gql`
mutation SaveRequerimientoActualVisitaCD($input: RequerimientoActualCDInput!) {
  saveRequerimientoActualVisitaCD(input: $input) {
    idVisitaCD
  }
}`;

export const adaptRequerimientosActualesCDInput = (data) => ({
  idVisita: data?.idVisita,
  requerimientosActuales: data?.obsRequerimientoActual
});

export default SAVE_REQUERIMIENTOS_ACTUALES_VISITA_CD;